// extracted by mini-css-extract-plugin
export var dataCell = "_qi-2";
export var dataRow = "_qi-0";
export var headerRow = "_qi-1";